// Auto-generated translation for lt.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:36:48.175459+00:00.

export const LANDINGS = {
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Daugiau arklių. Daugiau aiškumo. Daugiau užtikrintumo.",
    subtitle: "Atnaujinkite į Premium ir valdykite visus savo arklius be apribojimų — su pilna EquiCoach intelekto galia.",
    primaryCTA: {
      label: "Pradėkite 14 dienų nemokamai",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Visos kainos",
      href: "/#pricing",
    },
    audience: "Savininkams, sporto raiteliams ir arklių augintojams, turintiems kelis arklius.",
    features: [
      "Neribotai pridėti arklių",
      "Pilna kiekvieno arklio istorija",
      "Duomenų atsarginė kopija",
      "Išsamios EquiCoach įžvalgos",
      "Išmanieji pranešimai ir planavimas",
      "Sveikata ir treniruotės visiškai susietos",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mažiau nei €0,17 per dieną",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Atnaujinkite į Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Manežo raiteliams",
    title: "Tobulėk, net neturėdamas savo žirgo.",
    subtitle: "Sekite savo pamokas, treniruotes ir pažangą naudodami EquiSight — pigiau nei puodelis kavos per mėnesį mamai ar tėčiui. Arba skanus ledų suktinukas su plakta grietinėle.",
    primaryCTA: {
      label: "Pradėti su Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kaip tai veikia?",
      href: "#features",
    },
    problem: "Kaip manežo raitelis dažnai neturi savo žirgo, tačiau vis tiek nori augti ir išlaikyti aiškią apžvalgą apie savo pamokas, tikslus ir žirgus, ant kurių jojai.",
    solution: "Manežo funkcionalumas yra įtrauktas į Premium kaip standartinė funkcija — sekite savo asmeninę pažangą ir peržiūrėkite susietus manežo žirgus tik skaitymo režimu.",
    features: [
      "Treniruočių sekimas",
      "Tikslų nustatymas",
      "Pažangos stebėjimas",
      "Manežo žirgų peržiūra su vardu ir nuotrauka",
      "Nėra prieigos prie privačių sveikatos duomenų",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per mėnesį · manežo funkcionalumas įtrauktas",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Tapkite nariu",
      title: "Pradėkite kaip manežo raitelis.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Mankežams ir arklidėms",
    title: "Padarykite savo manežą skaitmeniškai prieinamą kiekvienam raiteliui.",
    subtitle: "Suteikite raiteliams ryšį su žirgais, pamokomis ir pažanga — nesidalindami jautriais arklidės duomenimis.",
    primaryCTA: {
      label: "Prašyti prieigos",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti modulius",
      href: "#features",
    },
    audience: "EquiSight padeda manežams ir arklidėms išlaikyti raitelių susidomėjimą ilgiau ir išsiskirti skaitmeniniu požiūriu.",
    features: [
      "Manežo žirgų matomumas raiteliams",
      "Kiekvieno žirgo vardas ir nuotrauka",
      "Raitelių susiejimas su žirgais",
      "Tik skaitymo prieiga jautriems duomenims",
      "Pamokų ir treniruočių istorija vienoje vietoje",
      "Naudotojų valdymas su vaidmenimis",
    ],
    benefits: [
      "Stipresnis raitelių įsitraukimas",
      "Profesionalesnis įvaizdis",
      "Papildoma skaitmeninė paslauga nariams",
      "Nauja pajamų srovė per programėlės naudojimą",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per mėnesį · manežo funkcionalumas raiteliams įtrauktas",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Aktyvuokite Manežo Modulį.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Veisimo modulis",
    title: "Kontroliuokite ciklą, nėštumą ir kumeliuko vystymąsi.",
    subtitle: "Pilnas veisimo modulis kumelių savininkams ir veisėjams — nuo dengimo iki kumeliuko, vienoje laiko juostoje.",
    primaryCTA: {
      label: "Aktyvuoti veisimo modulį",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti funkcijas",
      href: "#features",
    },
    audience: "Veisėjams, kumelių savininkams ir arklidėms, valdančioms kelias kumeles.",
    features: [
      "Ciklo sekimas",
      "Rujos registravimas",
      "Apvaisinimo datų įrašymas",
      "Atgalinė atskaita iki echoskopijų",
      "Nėštumo patikrinimų planavimas",
      "Kilmės knyga ir genealogija",
      "Kumeliuko vystymasis",
      "Visų nėščių kumelių apžvalga",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per mėnesį · Veisimo modulis įtrauktas į Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pradėkite šiandien",
      title: "Pradėkite veisimo valdymą.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Kanonininkų modulis",
    title: "Dirbkite išmaniau kaip kanonininkas. Fiksuokite viską profesionaliai.",
    subtitle: "Darbotvarkė, nuotraukos, pastabos ir gydymo istorija viename modulyje — mažiau nesusipratimų, tvirtesnė byla.",
    primaryCTA: {
      label: "Pradėti kaip kanonininkas",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti Professional paketą",
      href: "/professional",
    },
    audience: "Kanoninikams, kurie nori pagerinti apžvalgą, įrodymų rinkimą ir komunikaciją su klientais.",
    features: [
      "Asmeninė darbotvarkė",
      "Susitikimai pagal klientą",
      "Peržiūrėti arklių profilius",
      "Pridėti nuotraukas prieš ir po",
      "Užrašyti gydymą",
      "Fiksuoti patarimus ir pastabas",
      "ETA pranešimas klientui: \"Kanonininkas yra pakeliui\"",
    ],
    benefits: [
      "Profesionalesnis darbas",
      "Mažiau nesusipratimų",
      "Geresnė bylų sudarymas",
      "Tvirtesnė pozicija atsakomybės atveju",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per mėnesį · Kanonininkų modulis įtrauktas į Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Aktyvuokite kanonininkų modulį.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fizioterapijos / osteopatijos modulis",
    title: "Profesionaliai stebėkite kūną, judėjimą ir atsigavimą.",
    subtitle: "Fizioterapeutams ir osteopatams, kurie nori sistemingai prižiūrėti arklius.",
    primaryCTA: {
      label: "Pradėti kaip fizioterapeutas/osteopatas",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti Professional rinkinį",
      href: "/professional",
    },
    features: [
      "Kiekvieno arklio priėmimo anketa",
      "Kūno būklės duomenų registravimas",
      "Nuotraukų ir vaizdo įrašų pridėjimas",
      "Gydymo ataskaitos kūrimas",
      "Pratimų ir tolesnės priežiūros bendrinimas",
      "Atsigavimo proceso stebėjimas",
      "Kiekvieno arklio istorija",
    ],
    benefits: [
      "Geresnis supratimas laikui bėgant",
      "Profesionali atskaitomybė",
      "Aiški komunikacija su savininku, treneriu ir raiteliu",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per mėnesį · Fizioterapijos / osteopatijos modulis įtrauktas į Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Aktyvuokite fizioterapijos / osteopatijos modulį.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trenerio modulis",
    title: "Treniruokite raitelius su duomenimis, tikslais ir pažanga.",
    subtitle: "Padarykite treniruotes išmatuojamas, o pagalbą — profesionalesnę — vienam ar keliems raitininkams.",
    primaryCTA: {
      label: "Pradėti kaip treneris",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti Pro paketą",
      href: "/#pricing",
    },
    audience: "Instruktoriams, treneriams ir koučams, dirbantiems su keliais raiteliais ar žirgais.",
    features: [
      "Susieti raitelius",
      "Sekti žirgus",
      "Nustatyti treniruočių tikslus",
      "Teikti atsiliepimus",
      "Analizuoti varžybų rezultatus",
      "Peržiūrėti kiekvienos poros pažangą",
      "Naudoti protokolų analizes treniruočių fokusui",
    ],
    benefits: [
      "Geresnė pagalba",
      "Daugiau struktūros",
      "Profesionalesnė komunikacija",
      "Stipresnis ryšys su klientais",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per mėnesį · Trenerio modulis įtrauktas į Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Aktyvuokite trenerio modulį.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Varžybų analizė",
    title: "Nuo protokolo iki geresnių rezultatų.",
    subtitle: "Įkelkite varžybų protokolą ir sužinokite, kur prarandate taškus — ne tik peržiūrėkite savo rezultatą, bet supraskite, kaip tapti geresniu.",
    primaryCTA: {
      label: "Analizuokite pirmąjį protokolą",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti Premium",
      href: "/premium",
    },
    features: [
      "Protokolo nuotraukos įkėlimas",
      "Priekinės ir galinės pusės apdorojimas",
      "Klasės, pratimo numerio ir teisėjo atpažinimas",
      "Kiekvieno elemento balų analizė",
      "Komentarų apibendrinimas",
      "Stipriųjų ir silpnųjų vietų rodymas",
      "Tendencijos pagal arklio ir raitelio derinį",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per mėnesį · varžybų analizė įtraukta nuo Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Pradėkite varžybų analizę.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional rinkinys",
    title: "Specialistams, dirbantiems su arkliais.",
    subtitle: "Kalvis, odontologas, fizioterapeutas, osteopatas ar treneris: dirbkite kartu viename skaitmeniniame arklio byloje.",
    primaryCTA: {
      label: "Pradėti kaip specialistas",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Peržiūrėti atskirus modulius",
      href: "#features",
    },
    audience: "Professional rinkinys sujungia visus specialybės modulius į vieną prenumeratą.",
    features: [
      "Kalvio modulis",
      "Odontologijos modulis",
      "Fizioterapijos / Osteopatijos modulis",
      "Darbotvarkė ir klientų valdymas",
      "Arklių profiliai ir ataskaitos",
      "Gydymo istorija ir bylos sudarymas",
      "Ryšys su savininku",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per mėnesį · visi specialybės moduliai įtraukti",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasiruošę?",
      title: "Pasirinkite Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Arklio skubios pagalbos numeriai",
    title: "Tinkama pagalba visada po ranka.",
    subtitle: "Ekstremalios situacijos metu kiekviena sekundė svarbi. Su EquiSight visi svarbūs jūsų arklio kontaktai visada pasiekiami — vienas paspaudimas ir skambinate.",
    primaryCTA: {
      label: "Paruoškite savo skubios pagalbos kontaktus",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Pradėkite naudoti EquiSight nemokamai",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Skubios pagalbos kontaktai — tiesioginis skambutis, „WhatsApp\" žinutė arba navigacija iki veterinaro, klinikos ir kanopos kalvio",
      caption: "Vienas paspaudimas. Jokios panikos.",
      embeddedFrame: true,
    },
    problem: "Jūsų arklys serga — kolika, trauma, panika. Ir prasideda ieškojimas. Ką skambinti? Ar turite tinkamą numerį? Ar tai skubus numeris? Brangus laikas prarandamas.",
    solution: "Su EquiSight viskas pasiekiama iš karto. Jokio ieškojimo. Jokių abejonių. Vienas paspaudimas ir esate ryšyje.",
    scenario: {
      title: "Įsivaizduokite — jūsų arklys rodo kolikos požymius.",
      steps: [
        "Atidarote EquiSight",
        "Spaudžiate \"Veterinaras\"",
        "Skambinate tiesiogiai",
      ],
      tagline: "Jokio streso. Jokio ieškojimo. Tik veiksmas.",
    },
    features: [
      "Visi skubios pagalbos numeriai vienoje vietoje",
      "Vieno paspaudimo skambutis iš programėlės",
      "„WhatsApp\" žinutė vienu paspaudimu",
      "Tiesioginis navigavimas iki adreso",
      "Atskiras kontaktų sąrašas kiekvienam arkliui",
      "Veterinaras, klinika, kanopos kalvis, odontologas, fizioterapeutas",
      "Adresas ir maršruto aprašymas pasiekiami iš karto",
      "Pažymėkite mėgstamus numerius žvaigždute",
      "Skubios pagalbos numeriai (112, 144) visada viršuje",
    ],
    benefits: [
      "Ramybė ir kontrolė ekstremalios situacijos metu",
      "Visi arklidėje turi tuos pačius numerius po ranka",
      "Jokių pamirštų vizitinių kortelių",
      "Reaguokite keliomis sekundėmis greičiau skubios pagalbos atveju",
    ],
    audience: "Arklio savininkams, prižiūrėtojams, treneriams ir arklidėms — visiems, kurie yra atsakingi už arklį.",
    showcase: {
      eyebrow: "Iš anksto paruošta jums",
      title: "13 kontaktų kategorijų — paruošta pildyti.",
      description: "Nuo veterinaro ir skubios pagalbos klinikos iki balnų meistro, instruktoriaus ir ganyklų prižiūrėtojo. EquiSight pažįsta jūsų pasaulį ir iš anksto paruošia tinkamus kontaktų laukus. Paspauskite, užpildykite, baigta.",
      bullets: [
        "Skubi pagalba ir sveikata — veterinaras, skubi pagalba, klinika, apsinuodijimų linija",
        "Kasdienė priežiūra — kanopos kalvis, odontologas, fizioterapeutas, instruktorius",
        "Arklidė ir ganykla — arklidės savininkas, ganyklų prižiūrėtojas, pensiono arklidė",
        "Pašaras ir medžiagos — šieno, koncentratų, šiaudų tiekėjai",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Skubios pagalbos kontaktų valdymo ekranas — visi siūlomi kontaktai pagal kategoriją",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Arklio skubios pagalbos numerių kontrolinis sąrašas",
      items: [
        "Veterinaras",
        "Skubios pagalbos klinika (24/7)",
        "Gyvūnų greitoji pagalba · 144",
        "Kanopos kalvis",
        "Atsarginis kontaktinis asmuo",
        "Bendrasis pagalbos numeris · 112",
      ],
      cta: {
        label: "Atidarykite EquiSight ir užpildykite iš karto",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Skubios pagalbos numeriai",
          price: "Gratis",
          note: "Visada nemokama · visiems, kiekviename plane",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pasirūpinkite, kad būtumėte pasiruošę",
      title: "Kol dar nereikia.",
      href: "/#waitlist",
    },
    microcopy: [
      "Jokių įsipareigojimų",
      "Nustatoma per 2 minutes",
      "Visada keičiama",
    ],
  },
};

export default LANDINGS;
